import React from "react";
import { Helmet } from "react-helmet";

const HelmetComponent = ({title}: {title?: string}) => {
  return (
    <>
    {/* @ts-ignore */}
    <Helmet>
      <title>{`${title ? title + ' - ' : ''}Ontario`}</title>
     </Helmet>
    </>
  );
}

export default HelmetComponent;
